import request from '@/utils/request'
import { downloadBlob } from '../../utils/helpers'
import uuid from 'uniq-id'

export default {
    getPayments: async({ dispatch, commit }, params) => {
        commit('SET_LOAD', true)
        await request({
            method: 'get',
            url: 'payment',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                ...Object.select(params, [
                    'fromDate', 'toDate', 'type', 'status',
                    'taxiOrderId', 'orderId', 'clientId', 'page',
                    'phoneNumber', 'column', 'direction', 'excel'
                ])
            }
        })
            .then(res => {
                if (res.data && res.data.payments) {
                    commit('SET_PAGINATION', {
                        length: res.data.totalPages,
                        page: res.data.page,
                        total: res.data.total
                    })
                    commit('SET_PAYMENTS', res.data.payments)
                    commit('SET_LOAD', false)
                } else if (res.data && params.excel) {
                    downloadBlob(res.data, `Report_${uuid()}.xlsx`)
                }
            }).finally(() => {
                commit('SET_LOAD', false)
            })
    }
}
